export default {
    sk: {
        messages: {
            required: 'Toto pole je povinné',
            min: '{field} musí obsahovať aspoň 0:{min} znakov',
            confirmed: '{field} sa nezhoduje',
            email: 'Neplatná emailová adresa',
            date: 'Musí byť dátum formátu dd.mm.rrrr',
            tel: 'Musí byť telefónne číslo vo formáte +421000111222',
            between: 'Hodnota musí byť od 0:{min} do 1:{max}',
            size: 'Súbor musí mať najviac 0:{size} KB',
            length: 'Pole musí mať presne 0:{size} znakov',
            age_between: 'Veková hranica je od 0:{min} do 1:{max} rokov',
            numeric: 'Musí byť číslo'
        },
        names: {
            name: 'Meno',
            first_name: 'Meno',
            last_name: 'Priezvisko',
            email: 'Email',
            password: 'Heslo',
            password_confirmation: 'Potvrdenie hesla',
            old_password: 'Staré heslo',
            new_password: 'Nové heslo',
            new_password_confirmation: 'Potvrdenie nového hesla',
            'student_profile.zipcode': 'PSČ',
            'student_profile.date_of_birth': 'Dátum narodenia'
        }
    }
};
